export const networksMetrics = {
  google: { color: '#FBBC04', key: 'google', label: 'Google', icon: '/icons/networks/google.svg' },
  facebook: {
    color: '#0081FB',
    key: 'facebook',
    label: 'Meta',
    icon: '/icons/networks/meta.svg',
  },
  tiktok: { color: '#000000', key: 'tiktok', label: 'TikTok', icon: '/icons/networks/tiktok.svg' },
  bing: { color: '#FF7043', key: 'bing', label: 'Bing', icon: '/icons/networks/bing.svg' },
  organic: {
    color: '#7c899d',
    key: 'organic',
    label: 'Custom URLs',
    icon: '/icons/networks/organic.svg',
  },
  untracked: {
    color: '#536a8b',
    key: 'untracked',
    label: 'Non Attributed',
    icon: '/icons/networks/untracked.svg',
  },
};
